import script from "./coupon-item-user.vue?vue&type=script&setup=true&lang=js"
export * from "./coupon-item-user.vue?vue&type=script&setup=true&lang=js"

import "./coupon-item-user.vue?vue&type=style&index=0&id=09d514c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09d514c0"]])

export default __exports__